import { faChartLine, faIdCard, faToggleOn } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useServiceProduct'

const generateTabBarItems = (serviceProduct) => {
  const urls = generateUrls(serviceProduct)
  const {
    editServiceProductRelationsUrl, editServiceProductUrl, serviceProductAuditLogsUrl,
  } = urls

  return [
    {
      icon: faIdCard,
      href: editServiceProductUrl,
      key: 'details',
      title: serviceProduct?.short_name || 'Product Details',
    },
    {
      icon: faToggleOn,
      href: editServiceProductRelationsUrl,
      key: 'relations',
      title: 'Relations',
    },
    {
      icon: faChartLine,
      href: serviceProductAuditLogsUrl,
      key: 'auditLog',
      title: 'Audit Log',
    },
  ]
}

export default generateTabBarItems
